
import React, { useRef, useEffect } from 'react';
import StatCard from './StatCard';
import { Users, History, MapPin, Cpu } from 'lucide-react';

const StatsGrid = () => {
  const statsRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && statsRef.current) {
          statsRef.current.classList.add('animate-fade-in');
        }
      });
    }, { threshold: 0.1 });
    
    if (statsRef.current) observer.observe(statsRef.current);
    
    return () => observer.disconnect();
  }, []);
  
  const stats = [
    { value: '2000+', label: 'Clients Served', icon: <Users className="h-8 w-8 text-primary" /> },
    { value: '25+', label: 'Years in Business', icon: <History className="h-8 w-8 text-secondary" /> },
    { value: '3', label: 'Major Tech Hubs', icon: <MapPin className="h-8 w-8 text-accent" /> },
    { value: '1M+', label: 'Devices Engineered', icon: <Cpu className="h-8 w-8 text-primary" /> }
  ];
  
  return (
    <div 
      ref={statsRef} 
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16 opacity-0 transform translate-y-8 transition-all duration-700"
    >
      {stats.map((stat, index) => (
        <StatCard 
          key={index}
          value={stat.value}
          label={stat.label}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default StatsGrid;
